module.exports = __webpack_public_path__ + "static/media/noun_right_406172.54ec37e4.svg";